<template>
	<div>
		<StateBar class="w-100p" />
		<h2 class="fs-title text-center">Két ajánlat összehasonlítása</h2>
		<div class="con-1380 calc-full-content">
			<div class="calc-main-content two-offers">
				<table cellspacing="0" cellpadding="0" class="comparing" style="width: 100%">
					<tr>
						<th></th>
						<th></th>
						<th></th>
					</tr>
					<tr>
						<td><a href="javascript:void(0);" @click="back">Kilépés az összehasonlításból</a></td>
						<td></td>
						<td></td>
					</tr>
					<tr>
						<td>Biztosító neve</td>
						<td>
							<span class="title">{{ getSelectedOffers[0].insurer_name }} Biztosító</span>
							<img
								:src="getSelectedOffers[0].logo"
								:alt="getSelectedOffers[0].insurer_name"
								class="logo"
							/>
						</td>
						<td>
							<span class="title">{{ getSelectedOffers[1].insurer_name }} Biztosító</span>
							<img
								:src="getSelectedOffers[1].logo"
								:alt="getSelectedOffers[1].insurer_name"
								class="logo"
							/>
						</td>
					</tr>
					<tr>
						<td>Csomag neve</td>
						<td>
							<span class="title">{{ getSelectedOffers[0].product_name }}</span>
						</td>
						<td>
							<span class="title">{{ getSelectedOffers[1].product_name }}</span>
						</td>
					</tr>
					<tr>
						<td>Biztosítási összeg</td>
						<td class="bg-color">
							<span class="highlighted">{{ getSelectedOffers[0].sum_fee | toCurrency }}</span>
							<ul class="default">
								<li>Ingatlan: {{ getSelectedOffers[0].real_estate_value | toCurrency }}</li>
								<li>Ingóság: {{ getSelectedOffers[0].movables_value | toCurrency }}</li>
								<li>Értéktárgy: {{ getSelectedOffers[0].valuables_value | toCurrency }}</li>
								<li>
									Melléképület ingóság: {{ getSelectedOffers[0].outbuildings_value | toCurrency }}
								</li>
								<li>Egyéb építmények: {{ getSelectedOffers[0].buildings_value | toCurrency }}</li>
							</ul>
						</td>
						<td class="bg-color">
							<span class="highlighted">{{ getSelectedOffers[1].sum_fee | toCurrency }}</span>
							<ul class="default">
								<li>Ingatlan: {{ getSelectedOffers[1].real_estate_value | toCurrency }}</li>
								<li>Ingóság: {{ getSelectedOffers[1].movables_value | toCurrency }}</li>
								<li>Értéktárgy: {{ getSelectedOffers[1].valuables_value | toCurrency }}</li>
								<li>
									Melléképület ingóság: {{ getSelectedOffers[1].outbuildings_value | toCurrency }}
								</li>
								<li>Egyéb építmények: {{ getSelectedOffers[1].buildings_value | toCurrency }}</li>
							</ul>
						</td>
					</tr>
					<tr>
						<td>Díj</td>
						<td>
							<span class="highlighted">{{ getSelectedOffers[0].annual_fee | toCurrency }}</span>
						</td>
						<td>
							<span class="highlighted">{{ getSelectedOffers[1].annual_fee | toCurrency }}</span>
						</td>
					</tr>
					<tr>
						<td>Fizetendő díj</td>
						<td class="bg-color">
							<span class="highlighted">{{ getSelectedOffers[0].frequency_fee | toCurrency }}</span>
							<span class="default text-center">
								{{ paymentFrequencyTexts[getCalculation.payment_frequency] }} fizetendő
								<br />
								Évi: {{ getSelectedOffers[0].annual_fee | toCurrency }}
							</span>
						</td>
						<td class="bg-color">
							<span class="highlighted">{{ getSelectedOffers[1].frequency_fee | toCurrency }}</span>
							<span class="default text-center">
								{{ paymentFrequencyTexts[getCalculation.payment_frequency] }} fizetendő
								<br />
								Évi: {{ getSelectedOffers[1].annual_fee | toCurrency }}
							</span>
						</td>
					</tr>
					<tr>
						<td>Kedvezmények</td>
						<td>
							<ul class="default">
								<li v-for="(discount, index) in getSelectedOffers[0].discounts" :key="index">
									{{ discount.name }}: {{ discountValue(discount) }}
								</li>
							</ul>
						</td>
						<td>
							<ul class="default">
								<li v-for="(discount, index) in getSelectedOffers[1].discounts" :key="index">
									{{ discount.name }}: {{ discountValue(discount) }}
								</li>
							</ul>
						</td>
					</tr>
					<tr>
						<td>Alapcsomag</td>
						<td class="list form">
							<a class="toggleArrow-wrap">
								<span :class="['toggleArrow', !visible ? '' : 'open']" @click="toggle()">
									Alapcsomag
								</span>
							</a>
							<ul v-if="visible" class="basic-package">
								<li class="tick">Tűz</li>
								<li class="tick">Robbanás</li>
								<li class="tick">Villámcsapás másodlagos hatás</li>
								<li class="tick">Felhőszakadás</li>
								<li class="tick">Hónyomás</li>
								<li class="tick">Földrengés</li>
								<li class="tick">Ismeretlen építmény, ismeretlen</li>
								<li class="tick">üreg beomlása</li>
								<li class="tick">Idegen tárgy rádőlése</li>
								<li class="tick">Betöréses lopás, rablás, besurranás</li>
								<li class="tick">Üvegtörés</li>
								<li class="tick">Füst és koromszennyezés</li>
								<li class="tick">Villámcsapás</li>
								<li class="tick">Vihar</li>
								<li class="tick">Jégverés</li>
								<li class="tick">Árvíz</li>
								<li class="tick">Földcsuszamlás, kő-, szikla- és földomlás</li>
								<li class="tick">Idegen jármű ütközése</li>
								<li class="tick">Vízkár</li>
								<li class="tick">Rongálás, vandalizmus</li>
								<li class="tick">Felelősségbiztosítás</li>
							</ul>
						</td>
						<td class="list form">
							<a class="toggleArrow-wrap">
								<span :class="['toggleArrow', !visible ? '' : 'open']" @click="toggle()">
									Alapcsomag
								</span>
							</a>
							<ul v-if="visible" class="basic-package">
								<li class="tick">Tűz</li>
								<li class="tick">Robbanás</li>
								<li class="tick">Villámcsapás másodlagos hatás</li>
								<li class="tick">Felhőszakadás</li>
								<li class="tick">Hónyomás</li>
								<li class="tick">Földrengés</li>
								<li class="tick">Ismeretlen építmény, ismeretlen</li>
								<li class="tick">üreg beomlása</li>
								<li class="tick">Idegen tárgy rádőlése</li>
								<li class="tick">Betöréses lopás, rablás, besurranás</li>
								<li class="tick">Üvegtörés</li>
								<li class="tick">Füst és koromszennyezés</li>
								<li class="tick">Villámcsapás</li>
								<li class="tick">Vihar</li>
								<li class="tick">Jégverés</li>
								<li class="tick">Árvíz</li>
								<li class="tick">Földcsuszamlás, kő-, szikla- és földomlás</li>
								<li class="tick">Idegen jármű ütközése</li>
								<li class="tick">Vízkár</li>
								<li class="tick">Rongálás, vandalizmus</li>
								<li class="tick">Felelősségbiztosítás</li>
							</ul>
						</td>
					</tr>

					<tr>
						<td>Kiegészítő csomag</td>
						<td class="list form list-bg-color">
							<ul class="basic-package">
								<li
									v-for="(event, index) in computedInsuranceEvents(0)"
									:key="index"
									class="label"
									:class="{
										tick: event.includes,
										crossmark: !event.includes,
										'fs-bold': event.isChecked,
									}"
								>
									{{ event.name }}
									<span v-if="event.includes">- {{ event.fee | toCurrency }}</span>
								</li>
							</ul>
						</td>
						<td class="list form list-bg-color">
							<ul class="basic-package">
								<li
									v-for="(event, index) in computedInsuranceEvents(1)"
									:key="index"
									class="label"
									:class="{
										tick: event.includes,
										crossmark: !event.includes,
										'fs-bold': event.isChecked,
									}"
								>
									{{ event.name }}
									<span v-if="event.includes">- {{ event.fee | toCurrency }}</span>
								</li>
							</ul>
						</td>
					</tr>
					<tr>
						<td></td>
						<td><button class="offer-btn btn-blue" @click="handleContracting(0)">Ezt választom</button></td>
						<td><button class="offer-btn btn-blue" @click="handleContracting(1)">Ezt választom</button></td>
					</tr>
					<tr>
						<td><a href="javascript:void(0);" @click="back">Kilépés az összehasonlításból</a></td>
						<td></td>
						<td></td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import _ from 'lodash';
import DataLayer from '@/helpers/dataLayer.js';

export default {
	data() {
		return {
			visible: false,
			show: false,
			paymentFrequencyTexts: {
				0: 'Havonta',
				1: 'Negyedévente',
				2: 'Félévente',
				3: 'Évente',
			},
		};
	},
	components: {
	},
	computed: {
		...mapGetters(['getSelectedOffers', 'getCalculation', 'getSelectedInsuranceEvents', 'getInsuranceEvents']),
		...mapGetters('auth', ['isLoggedIn', 'getCurrentUser', 'isCustomerService', 'isAdmin', 'isVerified']),
		discountValue() {
			return discount => {
				return discount.percent === null
					? this.$options.filters.toCurrency(discount.value)
					: `${discount.percent}%`;
			};
		},
		computedInsuranceEvents() {
			return index => {
				const events = _.cloneDeep(this.getInsuranceEvents.extend);
				const sorted = _.orderBy(events, event => this.getSelectedInsuranceEvents().includes(event.id), 'desc');

				_.each(sorted, event => {
					const iEvent = _.filter(
						this.getSelectedOffers[index].insurance_events,
						iEvent => iEvent.id === event.id,
					);

					event.includes = _.map(
						_.filter(this.getSelectedOffers[index].insurance_events, event => event.included),
						event => event.id,
					).includes(event.id);
					event.isChecked = this.getSelectedInsuranceEvents().includes(event.id);
					event.fee = iEvent.length > 0 ? iEvent[0].fee : null;
				});

				return sorted;
			};
		},
	},
	methods: {
		...mapMutations(['showPopup', 'clearSelectedOffers', 'setInterestedOffer']),
		...mapMutations('contracting', ['setSelectedOffer']),
		...mapActions(['updateUserId']),
		toggle() {
			this.visible = !this.visible;
		},
		back() {
			this.clearSelectedOffers();
			this.$router.push({ name: 'comparison', params: { hash: this.$route.params.hash } });
		},
		async handleContracting(index) {
			const offer = this.getSelectedOffers[index];
			DataLayer.setEvent('Ajanlat_valasztas', { Biztosíto: offer.insurer_name });
			this.setSelectedOffer(offer);

			if (this.getCurrentUser === null) {
				this.showPopup('ContractingRegistration');
			} else if (!this.isVerified) {
				this.showPopup('ContractingVerify');
			} else {
				//await this.updateUserId();
				this.$router.push({
					name: 'contracting-base',
					params: {
						hash: this.$route.params.hash,
						insurer_uuid: offer.insurer_uuid,
					},
				});
			}
		},
	},
};
</script>
